var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 0.333252C26.1859 0.333252 33.6666 7.81034 33.6666 17.0096C33.6666 26.1895 26.1859 33.6666 16.9999 33.6666C7.81395 33.6666 0.333252 26.1895 0.333252 17.0096C0.333252 7.81034 7.81395 0.333252 16.9999 0.333252ZM15.1016 10.3831C14.7477 10.3831 14.4098 10.4635 14.0881 10.6243C13.6859 10.8494 13.3641 11.2032 13.1872 11.6212C13.0746 11.9107 12.8976 12.779 12.8976 12.7951C12.7206 13.7438 12.6241 15.2874 12.6241 16.9919C12.6241 18.6175 12.7206 20.0953 12.8654 21.0601C12.8815 21.0761 13.0585 22.1535 13.2515 22.5233C13.6055 23.1987 14.2972 23.6167 15.0372 23.6167H15.1016C15.5842 23.6007 16.5977 23.1826 16.5977 23.1665C18.303 22.459 21.6653 20.2561 23.0167 18.7928L23.1132 18.6963C23.2901 18.5195 23.5154 18.2461 23.5636 18.1818C23.821 17.8441 23.9497 17.426 23.9497 17.0096C23.9497 16.5416 23.8049 16.1075 23.5315 15.7537C23.4671 15.6894 23.2258 15.4161 23.0006 15.1909C21.6814 13.7759 18.2387 11.4604 16.4369 10.7529C16.1634 10.642 15.4716 10.3992 15.1016 10.3831Z",
    fill: "#F7FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.c13a66c0.svg";
export { ForwardRef as ReactComponent };